import { resolvePresetToNights } from "#app/config/tripPlannerPresets.js";
import { getSingleNightRoute } from "#app/utils/tripPlannerForm.js";

export function getDefaultTripNights(
  presets,
  facility,
  { aliasType, aliasLabel, prefillSelectedSiteIds, prefillMinStayLength } = {},
) {
  // `/api/v1/stay` deep links: the partner has already picked a specific
  // stay (one or more huts x N nights). Synthesize a custom trip route
  // where every night accepts any of those huts, and the number of
  // nights matches the deep-linked `minStayLength`.
  if (prefillSelectedSiteIds && prefillSelectedSiteIds.length > 0) {
    const nightCount = Math.max(prefillMinStayLength ?? 1, 1);
    return Array.from({ length: nightCount }, (_, index) => ({
      index,
      siteIds: [...prefillSelectedSiteIds],
    }));
  }

  if (aliasType && aliasLabel) {
    if (aliasType === "route" && presets?.routes) {
      const matchedRoute = Object.values(presets.routes).find((route) =>
        route.aliases?.some(
          (a) => a.toLowerCase() === aliasLabel.toLowerCase(),
        ),
      );
      if (matchedRoute) {
        return resolvePresetToNights(matchedRoute, facility.sites);
      }
    }

    if (aliasType === "site") {
      const site = facility.sites.find(
        (s) => s.name.toLowerCase() === aliasLabel.toLowerCase(),
      );
      if (site) {
        return [{ index: 0, siteIds: [site.id] }];
      }
    }
  }

  // No preset, or an area where a preset would be a guess (most requests
  // at such facilities are a single night): open on the one-night route.
  if (!presets?.routes || presets.area) return getSingleNightRoute();

  const firstRoute = Object.values(presets.routes)[0];
  if (!firstRoute) return getSingleNightRoute();

  return resolvePresetToNights(firstRoute, facility.sites);
}
